import { Button, Chip } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import type { IssuePickerProps } from './IssuePicker';
import {
  useIssuePickerStyles,
  STATE_CATEGORY_COLORS,
} from './useIssuePickerStyles';

function RichDetailsBadge({
  raw,
  className,
}: {
  raw: unknown;
  className: string;
}) {
  if (raw === null || typeof raw !== 'object') return null;
  return (
    <Chip
      label="Detalhes ricos disponíveis"
      variant="outlined"
      size="small"
      className={className}
    />
  );
}
export function IssuePickerSelection({
  selected,
  onSelect,
  richMode,
  disabled,
  onOpen,
}: IssuePickerProps & { onOpen: () => void }) {
  const classes = useIssuePickerStyles();
  if (!selected)
    return (
      <Button
        variant="outlined"
        onClick={onOpen}
        disabled={disabled}
        data-testid="issue-picker-open"
      >
        Vincular Issue
      </Button>
    );
  return (
    <div className={classes.searchRow}>
      <Chip
        label={`${selected.type ? `${selected.type}: ` : ''}${selected.title}`}
        color={STATE_CATEGORY_COLORS[selected.stateCategory] ?? 'default'}
        onDelete={() => onSelect(null)}
        deleteIcon={<ClearIcon />}
        data-testid="issue-picker-selected"
      />
      {richMode && (
        <RichDetailsBadge raw={selected.raw} className={classes.badge} />
      )}
      <Button
        variant="outlined"
        size="small"
        onClick={onOpen}
        disabled={disabled}
      >
        Trocar
      </Button>
    </div>
  );
}
